import React, { useEffect, useState } from "react";
import "@google/model-viewer/dist/model-viewer";
import Background from "../../Assets/Images/images.png";
const AssetViewer = ({ assetDetails }) => {
  const modelRef = React.useRef();
  const [assetFile, setAssetFile] = useState(null);

  useEffect(() => {
    let findAssetFile = assetDetails?.allAssetVersions?.find((item, index) => ["glb"].includes(item.data.type));
    findAssetFile = findAssetFile ? findAssetFile?.data?.assets[0].url : null;
    setAssetFile(findAssetFile);
  }, [assetDetails]);

  return (
    <model-viewer
      style={{ width: "100%", height: "100%" }}
      src={assetFile}
      alt={assetDetails?.name || ""}
      shadow-intensity="1"
      autoplay
      // skybox-image={"https://cdn.simulanis.io/sso/Assets/images.png"}
      camera-controls
      touch-action="pan-y"
      ar
      // ar-modes="webxr quick-look"
      ref={(ref) => {
        modelRef.current = ref;
      }}
    ></model-viewer>
  );
};

export default AssetViewer;
